import { render, staticRenderFns } from "./PrivateModeSetting.vue?vue&type=template&id=0bbeb0ba&scoped=true"
import script from "./PrivateModeSetting.vue?vue&type=script&lang=js"
export * from "./PrivateModeSetting.vue?vue&type=script&lang=js"
import style0 from "./PrivateModeSetting.vue?vue&type=style&index=0&id=0bbeb0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbeb0ba",
  null
  
)

export default component.exports